import React from 'react'

class CustomAvatar extends React.Component {
  render() {
    let christmasSpecial = require("images/special/Christmas.svg");
    let fallSpecial = require("images/special/FirstDayFall.svg")
    let springSpecial = require("images/special/FirstDaySpring.svg")
    let summerSpecial = require("images/special/FirstDaySummer.svg")
    let winterSpecial = require("images/special/FirstDayWinter.svg")
    let halloweenSpecial = require("images/special/Halloween.svg")
    return (
      <>
        <img style={{pointerEvents: "none"}} className={`${this.props.className} ${this.props.department}`} src={this.props.src} />
        {this.props.special == "christmas" &&
          <>
            <div className="christmas-special hat-box">
              <img className="hat" src={`/datapulse${christmasSpecial}`} />
            </div>
          </>
        }
        {this.props.special == "fall" &&
          <>
            <div className="fall-special hat-box">
              <img className="hat" src={`/datapulse${fallSpecial}`} />
            </div>
          </>
        }
        {this.props.special == "spring" &&
          <>
            <div className="spring-special hat-box">
              <img className="hat" src={`/datapulse${springSpecial}`} />
            </div>
          </>
        }
        {this.props.special == "summer" &&
          <>
            <div className="summer-special hat-box">
              <img className="hat" src={`/datapulse${summerSpecial}`} />
            </div>
          </>
        }
        {this.props.special == "winter" &&
          <>
            <div className="winter-special hat-box">
              <img className="hat" src={`/datapulse${winterSpecial}`} />
            </div>
          </>
        }
        {this.props.special == "halloween" &&
          <>
            <div className="halloween-special hat-box">
              <img className="hat" src={`/datapulse${halloweenSpecial}`} />
            </div>
          </>
        }
      </>
    );
  }
}

export default CustomAvatar;
